/* Koszyk Pan Pomidor — obietnica terminu, zwijanie progów.
   Cała reszta (ilości, usuwanie, przeliczanie) zostaje po stronie Dawn. */
(function () {
  'use strict';

  var DNI_W = ['w niedzielę', 'w poniedziałek', 'we wtorek', 'w środę', 'w czwartek', 'w piątek', 'w sobotę'];

  /* ── termin wysyłki / doręczenia ─────────────────────────────────────── */

  // Czas w strefie sklepu, niezależnie od zegara przeglądarki.
  function terazWarszawa() {
    try {
      return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Warsaw' }));
    } catch (e) {
      return new Date();
    }
  }

  function iso(d) {
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + m + '-' + dd;
  }

  function policzTermin(cfg) {
    var teraz = terazWarszawa();
    var godz = teraz.getHours() + teraz.getMinutes() / 60;

    var wysylkowy = function (d) {
      return cfg.dni.indexOf(d.getDay()) !== -1 && cfg.pomijane.indexOf(iso(d)) === -1;
    };

    // W poniedziałek najpierw wychodzą zamówienia z weekendu, więc „jeszcze dziś” obiecujemy tylko w dni z cfg.tegoSamego.
    var dzis = wysylkowy(teraz) && cfg.tegoSamego.indexOf(teraz.getDay()) !== -1 && godz < cfg.odciecie;
    var nadanie = new Date(teraz);
    if (!dzis) {
      var bezpiecznik = 0;
      do {
        nadanie.setDate(nadanie.getDate() + 1);
        bezpiecznik++;
      } while (!wysylkowy(nadanie) && bezpiecznik < 30);
    }

    var doreczenie = new Date(nadanie);
    doreczenie.setDate(doreczenie.getDate() + 1);

    var dzien = function (d) {
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    };
    var zaDni = function (d) {
      return Math.round((dzien(d) - dzien(teraz)) / 86400000);
    };

    var odliczanie = null;
    if (dzis) {
      var ms = (cfg.odciecie - godz) * 3600000;
      var g = Math.floor(ms / 3600000);
      var mi = Math.floor((ms % 3600000) / 60000);
      odliczanie = (g > 0 ? g + ' godz. ' : '') + mi + ' min';
    }

    return {
      dzis: dzis,
      odliczanie: odliczanie,
      nadanieDow: nadanie.getDay(),
      nadanieZa: zaDni(nadanie),
      doreczenieDow: doreczenie.getDay(),
      doreczenieZa: zaDni(doreczenie),
    };
  }

  function komunikat(t, tryb) {
    var kiedy = function (dow, za) {
      return za === 1 ? 'jutro' : DNI_W[dow];
    };
    if (tryb === 'dostawa') {
      return t.dzis
        ? '<b>Zamów w ciągu <span class="pp-c__cd">' + t.odliczanie + '</span></b> — dostarczymy <b>jutro</b>'
        : 'Twoją przesyłkę dostarczymy <b>' + kiedy(t.doreczenieDow, t.doreczenieZa) + '</b>';
    }
    return t.dzis
      ? '<b>Zamów w ciągu <span class="pp-c__cd">' + t.odliczanie + '</span></b> — wyślemy <b>jeszcze dziś</b>'
      : 'Twoją przesyłkę wyślemy <b>' + kiedy(t.nadanieDow, t.nadanieZa) + '</b>';
  }

  function odswiezTermin() {
    var pola = document.querySelectorAll('[data-pp-when]');
    for (var i = 0; i < pola.length; i++) {
      var el = pola[i];
      var dni = (el.dataset.ppDays || '1,2,3,4')
        .split(',')
        .map(function (x) {
          return parseInt(x.trim(), 10);
        })
        .filter(function (x) {
          return !isNaN(x);
        });
      var pomijane = (el.dataset.ppSkip || '')
        .split(',')
        .map(function (x) {
          return x.trim();
        })
        .filter(Boolean);
      var tegoSamego = (el.dataset.ppSameDay || '2,3,4')
        .split(',')
        .map(function (x) {
          return parseInt(x.trim(), 10);
        })
        .filter(function (x) {
          return !isNaN(x);
        });
      var cfg = {
        odciecie: parseFloat(el.dataset.ppCutoff || '13'),
        dni: dni,
        tegoSamego: tegoSamego,
        pomijane: pomijane,
      };
      var html = komunikat(policzTermin(cfg), el.dataset.ppMode || 'wysylka');
      if (el.dataset.ppRendered !== html) {
        el.querySelector('[data-pp-when-text]').innerHTML = html;
        el.dataset.ppRendered = html;
      }
    }
  }

  /* ── zwijanie etykiet progów przy przewijaniu listy ───────────────────── */

  document.addEventListener(
    'scroll',
    function (event) {
      var lista = event.target;
      if (!lista || !lista.classList || !lista.classList.contains('pp-c__main')) return;
      var drawer = lista.closest('.pp-c');
      if (!drawer) return;
      if (lista.scrollTop > 16) drawer.classList.add('is-tight');
      else if (lista.scrollTop < 6) drawer.classList.remove('is-tight');
    },
    true
  );

  /* ── uruchomienie i odświeżanie po przerysowaniu drawera ──────────────── */

  function start() {
    odswiezTermin();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Dawn podmienia całe wnętrze drawera — obserwator wraca z komunikatem terminu.
  var obs = new MutationObserver(function () {
    odswiezTermin();
  });
  var cel = document.querySelector('cart-drawer');
  if (cel) obs.observe(cel, { childList: true, subtree: true });

  // Odliczanie musi tykać, nawet gdy nic się nie dzieje.
  setInterval(odswiezTermin, 30000);
})();
